import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Popover } from '@barges/react';
import { SvgIcon } from '@common/sprites';
import { trackChatEndedEvent, trackEventSpentCredit, trackSessionSummaryEvent } from '@app/actions/chat';
import Chat from './chat';
import ChatEnded from './chat_ended';
import SelectChatCredit from '../chat_overlay/select_chat_credit';
import ChatPurchaseFlow from './ChatPurchaseFlow';
import Constants from '../../config/const';
import Ringing from '../chat_overlay/outgoin_call';
import WaitingComponent from './waiting';
import classes from './classes.module.scss';
import AdvisorEnded from '../voip_chat/advisor_ended';
import Spiner from '../../../common/helpers/spiner';

const { shared } = window;
export default class CreatedChat extends PureComponent {
  static propTypes = {
    connectChatProvider: PropTypes.func.isRequired,
    disconnectChatProvider: PropTypes.func.isRequired,
    hangupChat: PropTypes.func.isRequired,
    hangingUp: PropTypes.bool,
    state: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    purchaseOnBack: PropTypes.func,
    purchaseSuccess: PropTypes.func,
    totalCharged: PropTypes.string,
    uuid: PropTypes.string,
    orderId: PropTypes.number,
    userId: PropTypes.number.isRequired,
    advisorId: PropTypes.number.isRequired,
    totalDuration: PropTypes.number,
    profilePictureUrl: PropTypes.string.isRequired,
    isNewUser: PropTypes.bool,
    analyticEvents: PropTypes.object,
    setTopupPaidMinutes: PropTypes.func.isRequired,
    topupState: PropTypes.object.isRequired,
    creditCardProcessingError: PropTypes.object,
    clearCreditCardProcessing: PropTypes.func.isRequired,
    hideTopUpBanner: PropTypes.func.isRequired,
    advisorXfmProgram: PropTypes.object,
    userXfmProgram: PropTypes.object,
    loadAdvisor: PropTypes.func.isRequired
  };

  static defaultProps = {
    hangingUp: false,
    purchaseOnBack: null,
    purchaseSuccess: null,
    totalCharged: null,
    uuid: null,
    orderId: null,
    totalDuration: null,
    isNewUser: false,
    analyticEvents: null,
    creditCardProcessingError: null,
    advisorXfmProgram: {},
    userXfmProgram: {}
  };

  state = {
    topupError: null
  };

  componentDidMount() {
    this.handlePageHide = () => {
      const { disconnectChatProvider } = this.props;
      disconnectChatProvider();
    };
    window.addEventListener('pagehide', this.handlePageHide);
  }

  componentDidUpdate(prevProps) {
    const {
      state, totalCharged, connectChatProvider, uuid, userId, orderId, advisorId, totalDuration, disconnectChatProvider
    } = this.props;
    if (prevProps.state !== Constants.chatStates.ended
      && state === Constants.chatStates.ended) {
      const mbwChatAnalytics = disconnectChatProvider();
      trackEventSpentCredit(parseFloat(totalCharged).toFixed(2), userId, orderId);
      trackChatEndedEvent({
        chatType: Constants.chatType.text,
        advisorId, userId, orderId, totalCharged, totalDuration
      });
      trackSessionSummaryEvent({ orderId, sessionType: Constants.chatType.text, mbwChatAnalytics });
    }

    if (!prevProps.uuid && uuid) {
      connectChatProvider();
    }
  }

  componentWillUnmount() {
    const { disconnectChatProvider } = this.props;
    disconnectChatProvider();
    window.removeEventListener('pagehide', this.handlePageHide);
  }

  onTopupFailed(error) {
    this.setState({ topupError: error });
  }

  showTopupErrorIfNeed(overlay) {
    const { topupError } = this.state;
    const { topupState, hideTopUpBanner } = this.props;
    const { t, creditCardProcessingError, clearCreditCardProcessing } = this.props;

    if (!topupError && !creditCardProcessingError) {
      return topupState.state === 'processing' ? null : overlay;
    }

    const errorMessage = topupError?.errorMessage || creditCardProcessingError?.text || t('chat.topup_banner.error_message');

    const onCloseModal = () => {
      hideTopUpBanner();
      if (topupError) this.setState({ topupError: null });
      if (creditCardProcessingError) clearCreditCardProcessing();
    };

    return (
      <Popover
        isOpen
        centered
        className={ classes.topupErrorContainer }
        renderTitle={ () => (
          <div className={ classes.errorTitleRow }>
            <SvgIcon id="error_icon" size={ 24 } />
            <span className={ classes.errorTitle }>{t('chat.topup_banner.error_title')}</span>
          </div>
        ) }
      >
        <div className={ classes.errorBody }>
          <span>{ errorMessage }</span>
          <Button type="primary" onClick={ onCloseModal } title="Ok" />
        </div>
      </Popover>
    );
  }

  render() {
    const {
      state, purchaseOnBack, profilePictureUrl, isNewUser
    } = this.props;
    const renderTopImg = () => (
      <img
        className={ classes.advisorImage }
        src={ profilePictureUrl }
        alt=""
      />
    );
    let content = null;
    let overlay = null;
    const shouldShowChatContent = state === Constants.chatStates.started
      || state === Constants.chatStates.paused
      || state === Constants.chatStates.paymentRequiredOnContinue;
    const ringingArray = [Constants.chatStates.appStarting,
      Constants.chatStates.appConnecting,
      Constants.chatStates.ringing,
      Constants.chatStates.appConnectProvider];

    if (ringingArray.includes(state)) {
      content = <Ringing chatType={ Constants.chatType.text } />;
    } else if (state === Constants.chatStates.waiting) {
      content = <WaitingComponent />;
    } else if (shouldShowChatContent) {
      content = <Chat { ...this.props } onTopupFailed={ this.onTopupFailed.bind(this) } disabled={ state !== Constants.chatStates.started } />;
      if (state === Constants.chatStates.paused) {
        overlay = (
          <div className={ classes.addCreditContainer }>
            <Popover isOpen renderTopOverlay={ isNewUser && renderTopImg } className="add-credit-container">
              <SelectChatCredit
                chatType={ Constants.chatType.text }
                isContinue
                selectorOpenedTime={ new Date() }
              />
            </Popover>
          </div>
        );
        overlay = this.showTopupErrorIfNeed(overlay);
      } else if (state === Constants.chatStates.paymentRequiredOnContinue) {
        const { purchaseSuccess: onPurchaseSuccess } = this.props;
        overlay = (
          <div className={ classes.addCreditContainer }>
            <ChatPurchaseFlow
              chatType={ Constants.chatType.text }
              purchaseOnBack={ purchaseOnBack }
              purchaseSuccess={ onPurchaseSuccess }
            />
          </div>
        );
        overlay = this.showTopupErrorIfNeed(overlay);
      }
    } else if (state === Constants.chatStates.ended) {
      content = (
        <>
          <ChatEnded chatType={ Constants.chatType.text } />
          <AdvisorEnded chatType={ Constants.chatType.text } />
        </>
      );
      overlay = this.showTopupErrorIfNeed(overlay);
    } else if (state === Constants.chatStates.continuingChat) {
      overlay = <Spiner loaderColor={ shared.appColor } />;
    } else {
      content = (
        <div>
          TODO:
          {state}
        </div>
      );
    }

    // overlay over the content

    return (
      <div className={ classes.callingScreen }>
        {content}
        {overlay}
      </div>
    );
  }
}
